import utm from "../../modules/utm";

(function (w) {
    const blocks = document.querySelectorAll(".js-drift-inpage-bot-block");

    if (blocks.length > 0) {

        const tags = utm.getUtmTagsFromUrlOrCookie();

        for (let i = 0; i < blocks.length; i++) {
            const block = blocks[i];
            const iframe = block.querySelector("iframe");

            let src = iframe.dataset.src;

            if (tags.length > 0) {
                src += "?" + tags.map((tag) => tag[0] + "=" + encodeURIComponent(tag[1])).join("&");
            }

            src += (src.indexOf("?") > -1 ? "&" : "?") + "attr[sent_from_url]=" + encodeURIComponent(w.location.href.split(/[?#]/)[0]) + "&attr[sent_from_form]=chatbot";

            iframe.src = src;
        }
    }
})(window);
